import React from 'react';
import img from '../../imgs/payportal.png';

class TopNav extends React.Component {
  state = {
    mobileNav: false,
  };

  showMobileNav = () => {
    this.setState(prevState => ({
      mobileNav: !prevState.mobileNav,
    }));
  };

  render() {
    const { mobileNav } = this.state;
    return (
      <nav className="d-flex justify-content-between pt-2 top-nav">
        <a href="https://www.payportal.org" className="header-logo">
          <img src={img} alt="" width="100" />
        </a>

        { /* NAV FOR DESKTOP */ }
        <div className="nav d-none d-md-block">
          <ul>
            {/* The first class has to be the component class, else scrollTo will not work */}
            <a
              href="https://www.payportal.org/#services"
              rel="noopener noreferrer">
              Services
            </a>

            <a
              href="https://www.payportal.org/#pricing"
              target="_blank"
              rel="noopener noreferrer">
              Pricing
            </a>

            <a
              href="https://www.payportal.org/#contact"
              target="_blank"
              rel="noopener noreferrer">
              Contact
            </a>
          </ul>
        </div>
        <i className="material-icons d-md-none" onClick={this.showMobileNav}>{mobileNav ? 'close' : 'reorder'}</i>
        { /* NAV FOR MOBILE */ }
        {
          mobileNav && (
            <div className="nav-mobile font-weight-bold d-block d-md-none">
              <ul>
                {/* The first class has to be the component class, else scrollTo will not work */}
                <a
                  href="https://www.payportal.org/#services"
                  target="_blank"
                  rel="noopener noreferrer">
                  Services
                </a>

                <a
                  href="https://www.payportal.org/#pricing"
                  target="_blank"
                  rel="noopener noreferrer">
                  Pricing
                </a>

                <a
                  href="https://www.payportal.org/#contact"
                  target="_blank"
                  rel="noopener noreferrer">
                  Contact
                </a>
              </ul>
            </div>
          )
        }
      </nav>
    );
  }
}

export default TopNav;
